// extracted by mini-css-extract-plugin
export default {"container":"ModalEditComment_container__3tsJJ","contentContainer":"ModalEditComment_contentContainer__ZoMD9","buttonContainer":"ModalEditComment_buttonContainer__5L5m6"};